import { Box, Button, Card, CardActions, CardContent, Container, Typography, useTheme } from '@mui/material'
import { IconOnCircle } from '../data-display/IconOnCircle'
import { useNavigate } from 'react-router-dom'
import { useAuthentication } from '@eidsivabredband/app-framework'
import { EbIcon } from '@eidsivabredband/react-component-ui-package'

interface RestrictedAccessProps {
  errorCode: number
}

function RestrictedAccess({ errorCode }: RestrictedAccessProps) {
  const theme = useTheme()
  const navigate = useNavigate()
  const client = useAuthentication()

  const errorCodes: { [key: number]: { title: string; message: string } } = {
    403: {
      title: 'Du har ikke tilgang til denne siden',
      message: 'Du har ikke tilgang til denne siden. Hvis problemet vedvarer, kan du kontakte systemansvarlig eller prøve å laste inn siden på nytt.',
    },
    404: {
      title: '404 - Siden finnes ikke',
      message: 'Prøver du å komme deg inn i kriker og kroker som ikke finnes?',
    },
    500: {
      title: 'Oh no! 500 ganger vår feil!',
      message: 'Det har oppstått en feil. Hvis problemet vedvarer, kan du kontakte systemansvarlig eller prøve å laste inn siden på nytt.',
    },
  }

  const refreshPage = () => {
    navigate('/')
  }

  const handleSignOut = () => {
    client.logout()
  }

  return (
    <Container maxWidth="sm">
      <Card sx={{ mt: 2, p: 2 }} elevation={0}>
        <CardContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center"
            }}>
            <IconOnCircle color="primary.light" icon={<EbIcon icon={'ChatBot'} color={theme.palette.mode === 'dark' ? 'white' : ''} />} large />
            <Typography variant="h4" gutterBottom>
              {errorCodes[errorCode].title}
            </Typography>
            <Typography
              align="center"
              sx={{
                color: "text.secondary",
                marginBottom: "16px"
              }}>
              {errorCodes[errorCode].message}
            </Typography>
          </Box>
        </CardContent>

        <CardActions sx={{ justifyContent: 'center' }}>
          {errorCode === 403 && (
            <Button variant="contained" color="primary" onClick={handleSignOut} disableElevation>
              Logg ut
            </Button>
          )}
          {errorCode === 404 && (
            <Button variant="outlined" onClick={refreshPage} disableElevation>
              Til forsiden
            </Button>
          )}
        </CardActions>
      </Card>
    </Container>
  );
}

export default RestrictedAccess
